export function getStateByModel(name: string, nameSuffix = "") {
  return {
    quizName: name + nameSuffix,
    name: name + nameSuffix,
  };
}
